"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEditorX = exports.getEditorTypeFromLocation = void 0;
var editor_type_1 = require("@wix/wix-vod-constants/dist/common/editor-type");
function getEditorTypeFromLocation() {
    if (typeof window !== 'undefined' &&
        window.location.href.match(/editorx.com/)) {
        return editor_type_1.EDITOR_TYPE.EditorX;
    }
    return editor_type_1.EDITOR_TYPE.Editor;
}
exports.getEditorTypeFromLocation = getEditorTypeFromLocation;
function isEditorX() {
    return getEditorTypeFromLocation() === editor_type_1.EDITOR_TYPE.EditorX;
}
exports.isEditorX = isEditorX;
//# sourceMappingURL=editor-type.js.map